export const UMB_LANGUAGE_ITEM_REPOSITORY_ALIAS = 'Umb.Repository.LanguageItem';
export const UMB_LANGUAGE_STORE_ALIAS = 'Umb.Store.LanguageItem';
export { UMB_LANGUAGE_ITEM_STORE_CONTEXT } from './language-item.store.context-token.js';
